import {HTTP} from "../../../libs/HTTP";

class AccountApi {

    getCurrentUser() {
        return HTTP.get("/api/account/current")
            .then(response => response.data)
    }
}
const accountApi = new AccountApi();
export default accountApi;